<template>
    <div class="ali-phone-vert-dialog" v-show="visible">
        <header>
            <div class="title">虚拟号码拨打人员实名认证</div>
            <div class="close-box" @click="close"><span class="el-icon el-icon-close"></span></div>
        </header>

        <section class="content-box">
            应工信部要求，所有拨打虚拟号码的用户，必须在指定的链接进行实名备案；否则未实名认证的手机号码自4月25日起将无法打通虚拟号码。链接如下：
            <a href="https://cmccsign.com/identity_trust/#/login?companyTransactionId=fbcad111ad7d402abb8425010fcf815c&platformId=1733818705992" target="_blank">
                https://cmccsign.com/identity_trust/#/login?companyTransactionId=fbcad111ad7d402abb8425010fcf815c&platformId=1733818705992
            </a>
        </section>
    </div>
</template>

<script>
import request from '@/utils/http';
import { mapGetters } from 'vuex';
import { setLocal, getLocal } from '@/utils/storage.js';
import dayjs from 'dayjs';

const LOCAL_KEY = '__LSP_ALI_PHONE_VERT_DATE__';
const PAGES = [
    '/otp/appointment-center', // 预约中心
    '/otp/dispatch-center', // 调度中心
    '/otp/receipt-center' // 回单签收
];

export default {
    name: 'AliPhoneVertDialog',
    data() {
        return {
            visible: false,
            isExpired: true
        };
    },

    computed: {
        ...mapGetters(['user']),
        isLSP() {
            return window.location.pathname === '/transport.html';
        },
        // 只在指定页面和指定时间范围内可用
        enable() {
            return this.isLSP && PAGES.includes(this.$route.path) && !this.isExpired;
        }
    },

    watch: {
        enable(newVal) {
            this.$emit('enableChange', newVal);
        },
        '$route.path': {
            handler(newVal, oldVal) {
                this.close();
                if (this.isLSP && PAGES.includes(newVal)) {
                    this.isExpired = true;
                    this.updateExpired().then(this.checkAndShow);
                }
            },
            immediate: true
        }
    },

    methods: {
        close() {
            this.visible = false;
        },

        show() {
            this.visible = true;
        },

        toCache() {
            const cache = getLocal(LOCAL_KEY) || {};
            cache[this.user.userCode] = dayjs().format('YYYY-MM-DD');
            setLocal(LOCAL_KEY, cache);
        },
        /** 获取字典配置 */
        async getDictConfig() {
            try {
                const dictCode = 'OTP_ALI_PHONE_VERT_DATE';
                const res = await request({
                    url: '/api-mdm/dictionaryDetail/dict',
                    method: 'get',
                    params: { dictCodes: dictCode }
                });
                if (res && res.data) {
                    return res.data[dictCode] || {};
                }
            } catch (err) {};
            return {};
        },

        async updateExpired() {
            const { lastDay } = await this.getDictConfig();
            this.isExpired = lastDay ? dayjs().isAfter(lastDay, 'day') : false;
        },

        async checkAndShow() {
            if (!this.enable) return;
            // 1、检查是否已经提示过；
            const cache = getLocal(LOCAL_KEY) || {};
            const oldDay = cache[this.user.userCode]; // 上次提示的日期
            const curDay = dayjs();

            const isShowed = oldDay ? (curDay.isSame(oldDay, 'day') || curDay.isBefore(oldDay, 'day')) : false;
            if (isShowed) return;

            this.show();
            this.toCache();
        }
    }
};

</script>

<style lang="less" scoped>
    .ali-phone-vert-dialog {
        position: fixed;
        top: 40px;
        right: 40px;
        width: 360px;
        min-height: 220px;
        line-height: 1.5;
        z-index: 199999999;
        background-color: #fff;
        border: 1px solid #e6e6e6;
        header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px solid #e6e6e6;
            padding: 12px 20px;
            .title {
                line-height: 24px;
                font-size: 16px;
                color: #252626;;
            }
        }

        .close-box {
            width: 20px;
            height: 20px;
            font-size: 16px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            .el-icon-close {
                &:hover {
                    background-color: transparent;
                    color: inherit;
                }

                &:before {
                    font-size: 16px;
                    transform: scale(1);
                    background-color: transparent !important;
                    margin-left: 0px;
                    vertical-align: 0px;
                }
            }
        }

        .content-box {
            font-size: 14px;
            padding: 16px;
            color: #555757;
            word-break: break-all;
            a {
                color: #00BCBF;
                &:hover {
                    text-decoration: underline;
                }
            }
        }

    }
</style>
